import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Header } from './presenters/components/header';
import { Footer } from './presenters/components/footer';
import { router } from './Routes';
import { createContext, useEffect, useState } from 'react';
import { loadStaticValues } from './insfrastructure/services/static_values';
import { retrieveCandidate } from './insfrastructure/services/candidates';
import { parseJwt } from './insfrastructure/utils/JWTParser';
import './styles/main.sass';
import { retrieveCompanyManager } from './insfrastructure/services/companies';


const loggedRoutes = [
    '/offers',
    '/job-subscriptions',
    '/candidates',
    '/profile'
];

const jobDetailRoutes = [
    '/offers/',
    '/job-subscriptions'
];

axios.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem('user_id');
      localStorage.removeItem('candidate_id');
      localStorage.removeItem('manager_id');
      localStorage.removeItem('legacy_password_login');
      localStorage.removeItem('auth_token');
      if (loggedRoutes.filter(route => window.location.pathname.includes(route)).length > 0) {
        // Armazenar a rota de origem para exibir mensagem específica
        if (window.location.pathname === '/offers' || 
            jobDetailRoutes.some(route => window.location.pathname.includes(route))) {
          sessionStorage.setItem('redirect_from_offers', 'true');
        }
        router.navigate('/login');
      }
      sessionStorage.clear();
      
      return Promise.reject(error)
    }

    // const originalRequest = error.config;
    // if (error.response.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true
    //   const refreshToken = localStorageService.getRefreshToken()
    //   return axios
    //     .post('/auth/token', {
    //       refresh_token: refreshToken
    //     })
    //     .then(res => {
    //       if (res.status === 201) {
    //         localStorageService.setToken(res.data)
    //         axios.defaults.headers.common['Authorization'] =
    //           'Bearer ' + localStorageService.getAccessToken()
    //         return axios(originalRequest)
    //       }
    //     })
    // }
    return Promise.reject(error)
  }
)

export const UserdataContext = createContext<any>(null);

export default function App() {
  const [staticValues, setStaticValues] = useState<any>(null)
  const [userData, setUserData] = useState<any>(null)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    loadStaticValues().then(staticValues => {
      localStorage.setItem('static_values', JSON.stringify(staticValues));
      setStaticValues(staticValues);
    });    
  }, [])

  useEffect(() => {
    checkLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const checkLogin = async () => {
    const parsedJWT = parseJwt(localStorage.getItem('auth_token') + '');

    if (!parsedJWT) {
      onLogout();

      return;
    };

    if(!parsedJWT?.user_id || (!parsedJWT?.manager_id && !parsedJWT?.candidate_id)) {
      onLogout();

      return;
    };

    if (parsedJWT.legacy_password_login === true && !['/reset-password', '/validate-token'].includes(location.pathname)) {
      router.navigate('/reset-password');

      return;
    };

    try {
      let userdata: any = {};

      if (parsedJWT.candidate_id) {
        userdata = await retrieveCandidate();
        userdata.usertype = parsedJWT.profiles[0];
      } else {
        userdata = await retrieveCompanyManager();
        userdata.usertype = parsedJWT.profiles[0];
      };
      
      setUserData(userdata);
    } catch (error) {
      console.log(error);
      onLogout();
    };
  }

  const onLogout = () => {
    localStorage.removeItem('user_id');
    localStorage.removeItem('candidate_id');
    localStorage.removeItem('manager_id');
    localStorage.removeItem('legacy_password_login');
    localStorage.removeItem('auth_token');
    sessionStorage.clear();
    setUserData(null);
    if (loggedRoutes.filter(route => location.pathname.includes(route)).length > 0) {
      // Armazenar a rota de origem para exibir mensagem específica
      if (location.pathname === '/offers' || 
          jobDetailRoutes.some(route => location.pathname.includes(route))) {
        sessionStorage.setItem('redirect_from_offers', 'true');
      }
      navigate('/login');  
    };
  }
  
  return (
    <UserdataContext.Provider value={{userData, setUserData}}>
      {staticValues &&
      <div className="page">
        <Header />
        <div className='page-content'>
          <Outlet />
        </div>
        <Footer/>
      </div>}
    </UserdataContext.Provider>
  )
}
